/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Zns_Purpose_Not_AvailableInputs */

const vi_error_zns_purpose_not_available = /** @type {(inputs: Error_Zns_Purpose_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mục đích này chưa mở trong đợt này nên chưa gán mẫu được.`)
};

/**

* @param {Error_Zns_Purpose_Not_AvailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zns_purpose_not_available = /** @type {((inputs?: Error_Zns_Purpose_Not_AvailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zns_Purpose_Not_AvailableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zns_purpose_not_available(inputs)
});